import React from 'react'
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';
import Causes from '../../api/cause'

const CauseSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={`causes-section section-padding ${props.cClass}`}>
            <div className="container-fluid">
                <div className="section-title-s2">
                    <span>#Causes</span>
                    <h2>Popular  <span>causes</span></h2>
                </div>
                <div className="content-area causes-slider">
                    <Swiper
                        modules={[Navigation, A11y]}
                        spaceBetween={30}
                        slidesPerView={3}
                        navigation
                        loop={true}
                        speed={1000}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            1400: {
                                slidesPerView: 3,
                            },
                            1024: {
                                slidesPerView: 2,
                            },
                            991: {
                                slidesPerView: 2,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            575: {
                                slidesPerView: 1,
                            },
                            480: {
                                slidesPerView: 1,
                            },
                        }}
                    >
                        {Causes.slice(0, 6).map((Cause, citem) => (
                            <SwiperSlide key={citem}>
                                <div className="item">
                                    <div className="inner">
                                        <div className="img-holder">
                                            <img src={Cause.cImg} alt="" />
                                        </div>
                                        <div className="overlay">
                                            <div className="overlay-content">
                                                <div className="progress">
                                                    <div className="progress-bar" style={{ width: `${Cause.process}%` }}>
                                                        <span className="progress-value">{Cause.process}%</span>
                                                    </div>
                                                </div>
                                                <h3><Link onClick={ClickHandler} to={`/cause-single/${Cause.slug}`}>{Cause.cTitle}</Link></h3>
                                                <div className="goal-raised">
                                                    <span>${Cause.Goal} raised of ${Cause.Raised}</span>
                                                    <Link onClick={ClickHandler} to={`/cause-single/${Cause.slug}`} className="donate-btn"><i className="fi flaticon-heart-1"></i>Donate</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default CauseSection;